import styled from 'styled-components';

import { DESKTOP_MIN_BREAK, GTM_DATA_ATTRIBUTE } from '#/shared/constants';

export const StopListBody = styled.div.attrs(props => ({
  [GTM_DATA_ATTRIBUTE]: props.dataGtm,
}))`
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  max-width: ${DESKTOP_MIN_BREAK};
  margin: 0;
  padding: 0 8px;
  background-color: ${props => props.theme.backgroundColor};
`;

export const StopListNoStopsMessageBody = styled.div`
  display: flex;
  justify-content: center;
  margin: 1em 0;
  padding: 0.75em;
  border: solid 1.2px;
  border-radius: 0.25em;
  border-color: ${({ theme }) => theme.activeButtonHover2};
`;

export const ButtonWrap = styled.div`
  display: flex;
  flex: 0 0 auto;
  margin: 0 auto 10px;
  min-width: 300px;
  max-width: 400px;
`;

export const StationInfoLane = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  font-size: 0.875em;
  margin: 0.75em 0 0.25em 0;
`;

export const GroupedStopName = styled.span`
  font-weight: 600;
`;

export const GroupedStopDistance = styled.span`
  font-size: 0.85em;
  margin: 0 0 0 0.75em;
`;

export default StopListBody;
